/**
 * Barra "Aggiungi al carrello" fissa su mobile (blocks/sticky-add-to-cart.liquid).
 * Si mostra quando il pulsante principale è uscito dallo schermo verso l'alto.
 * Il pulsante della barra clicca quello principale; se non è disponibile (variante
 * esaurita o non scelta) riporta l'utente al selettore taglie.
 */
class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.mainButton = document.querySelector('.product-details button[name="add"]');
    this.priceSource = document.querySelector('.product-details product-price');
    this.priceTarget = this.querySelector('[data-price]');
    this.addButton = this.querySelector('[data-add]');
    if (!this.mainButton || !this.addButton) return;

    this.addButton.addEventListener('click', () => this.handleClick());

    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    document.body.classList.remove('sticky-atc-visible');
  }

  /** Visibile quando il pulsante principale è sopra il bordo superiore dello schermo. */
  update() {
    this.toggle(this.mainButton.getBoundingClientRect().bottom < 0);
  }

  toggle(visible) {
    if (visible === this.classList.contains('is-visible')) return;
    if (visible) this.syncState();
    this.classList.toggle('is-visible', visible);
    document.body.classList.toggle('sticky-atc-visible', visible);
  }

  syncState() {
    const price = this.priceSource?.querySelector('.price');
    if (price && this.priceTarget) this.priceTarget.textContent = price.textContent.trim();
  }

  handleClick() {
    if (this.mainButton.disabled) {
      const picker = document.querySelector('.product-details variant-picker') ?? this.mainButton;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    this.mainButton.click();
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
